// A small card that asks one thing ("Become a Knight?") with two or three answers. Click, tap, or use the keys:
// left/right (or up/down) to pick, Enter or Space to choose, Escape for the last answer (usually "Not now").
export interface ChoiceOpt { label: string; primary?: boolean; run?: () => void }

let open: { root: HTMLElement; opts: ChoiceOpt[]; i: number; done: (i: number) => void } | null = null;

export const choiceOpen = (): boolean => !!open;

export function ask(title: string, text: string, opts: ChoiceOpt[], icon?: string): void {
  close();
  const root = document.createElement('div'); root.className = 'choice'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-label', title);
  const card = document.createElement('div'); card.className = 'choice-card';
  const h = document.createElement('h3'); h.textContent = (icon ? icon + ' ' : '') + title;
  const p = document.createElement('p'); p.textContent = text;
  const row = document.createElement('div'); row.className = 'choice-row';
  const btns = opts.map((o, i) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'btn' + (o.primary ? ' primary' : ''); b.textContent = o.label; b.addEventListener('click', () => pick(i)); row.append(b); return b; });
  card.append(h, p, row); root.append(card); document.body.append(root);
  const pick = (i: number) => { const o = opts[i]; close(); o?.run?.(); };
  open = { root, opts, i: Math.max(0, opts.findIndex(o => o.primary)), done: pick };
  const focus = () => btns[open!.i]?.focus();
  setTimeout(focus, 0);
  (root as HTMLElement & { _btns?: HTMLButtonElement[] })._btns = btns;
}

export function close(): void { open?.root.remove(); open = null; }

/** Keys while a choice is open: returns true when it used the key. */
export function choiceKey(k: string): boolean {
  if (!open) return false;
  const btns = (open.root as HTMLElement & { _btns?: HTMLButtonElement[] })._btns ?? [];
  if (k === 'ArrowLeft' || k === 'ArrowUp') { open.i = (open.i + btns.length - 1) % btns.length; btns[open.i]?.focus(); return true; }
  if (k === 'ArrowRight' || k === 'ArrowDown') { open.i = (open.i + 1) % btns.length; btns[open.i]?.focus(); return true; }
  if (k === 'Enter' || k === ' ' || k === 'e' || k === 'E') { open.done(open.i); return true; }
  if (k === 'Escape') { open.done(open.opts.length - 1); return true; }
  return true;   // swallow everything else while it's up
}
